import React from 'react'
import PropTypes from 'prop-types'

import logo from '../images/icon.png'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            {/* <span className="icon fa-diamond"><img src={logo} alt="farverio" /></span> */}
            <span className="icon"><img src={logo} alt="farverio" /></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Stephen Farver</h1>
                <p>I'm A programmer, growth hacker, & all-around quant <br />
                who's always searching for new opportunities to <br />
                learn more and drive additional value for clients.</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>Intro</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('work')}}>Work</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('about')}}>About</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
